import { application } from "../../../app"

import AutosubmitController from "./autosubmit_controller"
application.register("form--autosubmit", AutosubmitController)

import NestedFormController from "./nested"
import CheckboxesActivatorController from "./checkboxes_activator"
application.register("form--nested", NestedFormController)
application.register("form--checkboxes-activator", CheckboxesActivatorController)
